import { Component, Input, OnInit } from '@angular/core';
import { ChartConfigService } from 'src/app/utils/chart/chart-config.service';
import { VehiculeClassification } from '../../activity-vehicule-classifications.model';
import { ActivityVehiculeClassificationsService } from '../../activity-vehicule-classifications.service';
const Highcharts = require('highcharts');
require('highcharts/modules/exporting')(Highcharts);

@Component({
  selector: 'app-classification-sinistre-chart',
  templateUrl: './classification-sinistre-chart.component.html',
  styleUrls: ['./classification-sinistre-chart.component.css']
})
export class ClassificationSinistreChartComponent implements OnInit {

  classmentObject:Object | null = null;
  sinistreClassments: VehiculeClassification[] = [];


  @Input()
  set sinistres(sinistres: VehiculeClassification[]) {
    if (sinistres) {
      this.sinistreClassments = Object.assign(sinistres);
      this.sinistreChart();
    }
  }

  constructor(private chartConfig : ChartConfigService,
    private classificationService:ActivityVehiculeClassificationsService
  ) { }

  ngOnInit() {
    this.sinistreChart();
  }

  sinistreChart() {
    this.chartConfig.setHighCartsLang();
    var seriesData = [];

    for (let classment of this.sinistreClassments.filter(c => c.total > 0)) {
      seriesData.push({name:classment.driver,y:classment.total,color:this.classificationService.getColorFromName(classment.driver), avatarUri: classment.avatarUri})
    }

    this.classmentObject = {
      chart: {
        type: 'column'
      },
      title: {
        text: 'Sinistre',
        align: 'center',
        style: {
          fontWeight: 'bold'
        }
      },
      xAxis: {
        type: 'category',

        labels: {
          rotation: -45,
          style: {
            color: "#000000",
            fontWeight: 'bold',
            textDecoration: "underline"
          }
        }
      },
      yAxis: {
        title: {
          text: 'Total'
        },
        labels: {
          enabled: false
        }
      },
      legend: {
        enabled: false
      },
      accessibility: {
        point: {
          valueSuffix: 'Total'
        }
      }, credits: {
        enabled: false
      },
      tooltip: {
        useHTML: true,
        formatter: function(this: any): string {
          const avatar = this.point.avatarUri ? this.point.avatarUri : '';
          return `
            <div style="display:flex; align-items:center;">
              <img src="${avatar}" style="width:40px; height:40px; border-radius:50%; margin-right:5px;" />
              <div>
                <b>${this.point.name}</b><br/>
                ${this.point.y}
              </div>
            </div>
          `;
        }
      },
      plotOptions: {
        column: {
          borderRadius: 5
        },
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: false,
            format: '{point.y:.2f} '
          }
        }
      },
      series: [{
        colorByPoint: true,
        data: seriesData
      }]
    }
    Highcharts.chart('classmentSinistreObject', this.classmentObject);
  }



}
